import React from 'react';
import './ConfirmDialog.scss'; // Tu peux styliser ton modal via un fichier CSS
import { Button } from 'react-bootstrap';

interface ConfirmDialogProps {
    title: string;
    message: string;
    isOpen: boolean;
    button1Libelle?: string;
    button2Libelle?: string;
    button1ClassName?: string;
    button2ClassName?: string;
    onButton1?: () => void,
    onButton2?: () => void 
  }

  const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ title, message,button1Libelle,button2Libelle,button1ClassName,button2ClassName, onButton1, onButton2, isOpen }) => {
    
  if (!isOpen) {
        return null;
    }

  return (
    <div className="confirm-dialog-overlay">
      <div className="confirm-dialog">
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="confirm-dialog-buttons">
        {onButton1 && <Button className={`buttonConfirm ${button1ClassName}`} onClick={onButton1}>{button1Libelle}</Button>}
        {onButton2 && <Button className={`buttonConfirm ${button1ClassName}`} onClick={onButton2}>{button2Libelle}</Button>}
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
